import { useTranslation } from 'react-i18next'

import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'

interface MoveLocationConfirmationPopupProps {
  onClose: VoidFunction
  onConfirm: () => Promise<void>
  oldLocationName?: string
}

export const MoveLocationConfirmationPopup = ({
  onClose,
  onConfirm,
  oldLocationName,
}: MoveLocationConfirmationPopupProps) => {
  const { t } = useTranslation(['reservations'])

  const handleConfirm = async () => {
    await onConfirm()
    onClose()
  }

  return (
    <ConfirmationPopup
      title={t('reservations:details.details.moveReservationModalTitle')}
      variant="info"
      confirmText={t('reservations:details.details.moveReservation')}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography>
        {t('reservations:details.details.moveReservationModalBody', {
          oldLocationName: oldLocationName || '',
        })}
      </Typography>
    </ConfirmationPopup>
  )
}
